"use client";

import type { ReactElement } from "react";
import { useState } from "react";
import { useDidMount } from "rooks";

export function SafeHydrate({ children, asFragment = true }: { children: ReactElement; asFragment?: boolean }) {
  const [isSSR, setIsSSR] = useState(true);

  useDidMount(() => {
    setIsSSR(false);
  });

  // Determine content based on SSR state and fragment preference
  const content = isSSR ? null : children;
  return asFragment ? content : <div suppressHydrationWarning>{content}</div>;
}
